// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"872caa37","977":"b8256b02"}[chunkId] + ".chunk.js";
};